import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type InitialStateType = {
    isCollapsed: boolean;
};

const initialState: InitialStateType = {
    isCollapsed: false,
};

const marketingLayoutSlice: any = createSlice({
    name: "marketingLayout",
    initialState,
    reducers: {
        setIsCollapsed: (state, action: PayloadAction<boolean>) => {
            state.isCollapsed = action.payload;
        },
    },
});

export const { setIsCollapsed } = marketingLayoutSlice.actions;
export default marketingLayoutSlice.reducer;
